// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__37IEL","col":"CardReaderDesc_col__rYMsW","label":"CardReaderDesc_label__zNphK"};